import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin, Row, Col, Divider, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import useAuthContext from '../../contexts/AuthContext';
import DescriptionList from '../../components/descriptionList/DescriptionList';
import list from './informationList';
import TelecomInvoicesTable from './TelecomInvoicesTable';
import ConsumptionHistory from './ConsumptionHistory';
import { ContentCustom, PageHeaderCustom } from '../../components';

const ShowAsset = () => {
  const { id, type } = useParams();
  const { assetList, extraDetailsList, energyRelatedDetailsList } = list;
  const { dispatchAPI } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const { t } = useTranslation();
  const [asset, setAsset] = useState({});

  const getAsset = async () => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/assets?_id=${id}&populate=contract,people,phone_contract,telecomInvoices.phone_contract,site`
      });
      setAsset(data[0]);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      await getAsset();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const displayOverageButton = () =>
    !!(
      asset &&
      asset.telecomInvoices &&
      asset.telecomInvoices[asset.telecomInvoices.length - 1] &&
      (asset.telecomInvoices[asset.telecomInvoices.length - 1]
        .overage_data_amount ||
        asset.telecomInvoices[asset.telecomInvoices.length - 1]
          .overage_messages_amount ||
        asset.telecomInvoices[asset.telecomInvoices.length - 1]
          .overage_voice_amount)
    );

  const handleDownloadOverageReport = async () => {
    setIsDownloadLoading(true);
    try {
      const response = await dispatchAPI('POST', {
        url: `/telecom-invoices/download-report/${asset.telecomInvoices[asset.telecomInvoices.length - 1]._id}`,
        responseType: 'arraybuffer'
      });
      const bfArray = new Uint8Array(response.data.data.data);
      const blob = new Blob([bfArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
    } catch (e) {
      if (e.response) message.error(e.response.status);
    }
    setIsDownloadLoading(false);
  };

  return (
    <>
      <PageHeaderCustom title={t('assets.showAsset.title')} />
      <ContentCustom>
        {isLoading ? (
          <Spin
            style={{
              textAlign: 'center',
              borderRadius: '4px',
              marginBottom: '20px',
              padding: '30px 50px',
              margin: '20px 0',
              width: '100%',
              height: '100%'
            }}
          />
        ) : (
          <Row>
            {type === 'Telecom' ? (
              <Row>
                <Col xs={{ span: 24 }} md={{ span: 10 }}>
                  <DescriptionList data={assetList(asset, t)[type]} />
                  {displayOverageButton() && (
                    <Button
                      loading={isDownloadLoading}
                      type="primary"
                      onClick={handleDownloadOverageReport}
                    >
                      Rapport Hors-Forfait
                    </Button>
                  )}
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 14 }}>
                  <ConsumptionHistory invoices={asset.telecomInvoices} />
                </Col>
              </Row>
            ) : (
              type && <DescriptionList data={assetList(asset, t)[type]} />
            )}
            {type === 'IT' && (
              <>
                <Divider style={{ marginTop: 24 }} orientation="left">
                  {t('assets.showAsset.extraDivider')}
                </Divider>
                <DescriptionList data={extraDetailsList(asset, t)[type]} />
                <Divider style={{ marginTop: 24 }} orientation="left">
                  {t('assets.showAsset.energyRelatedDivider')}
                </Divider>
                <DescriptionList
                  data={energyRelatedDetailsList(asset, t)[type]}
                />
              </>
            )}
          </Row>
        )}
      </ContentCustom>
      {type === 'Telecom' && (
        <TelecomInvoicesTable data={asset.telecomInvoices} />
      )}
    </>
  );
};

export default ShowAsset;
